<div class="app-screen"></div>
<style lang="scss">
  .app-screen {
    margin-top: 20px;
  }
</style>
